module.exports = __webpack_public_path__ + "img/dec14_06.8535d8d2.jpeg";